import React from 'react';
import classNames from 'classnames';
import './Avatar.scss';
import FontAwesomeIcon from '../Icon';
import Skeleton from '../Skeleton/Skeleton';

const AVATAR_SIZE_REM: Record<string, string> = {
  small: '2.2rem',
  medium: '3.8rem',
  chat: '4.4rem',
  profile: '10rem',
  'settings-profile': '12rem',
  large: '14rem',
};

const Avatar = ({ badge, size, url, loading }: any) => {
  if (loading) {
    const dim: string = AVATAR_SIZE_REM[size] ?? '7rem';
    return (
      <div
        className={classNames('avatar', 'is-loading', {
          [`size-${size}`]: size,
        })}
      >
        <Skeleton variant="circle" width={dim} height={dim} />
      </div>
    );
  }

  return (
    <div
      className={classNames('avatar', {
        [`size-${size}`]: size,
      })}
    >
      {badge &&
        ['property-manager', 'service-provider', 'home-owner'].indexOf(badge) >
          -1 && (
          <div className="avatar-badge">
            <FontAwesomeIcon
              size="tiny"
              weight="solid"
              glyph={
                badge === 'property-manager'
                  ? 'shield-alt'
                  : badge === 'service-provider'
                    ? 'wrench'
                    : badge === 'home-owner'
                      ? 'home'
                      : null
              }
            />
          </div>
        )}
      {badge === 'count' ? (
        <div className="avatar-badge">
          <FontAwesomeIcon
            size="tiny"
            weight="solid"
            glyph={badge === 'count' ? 'ellipsis-h' : null}
          />
        </div>
      ) : null}
      <img
        src={url || '/assets/avatar.svg'}
        className="avatar-image"
        alt="avatar"
      />
    </div>
  );
};

export default Avatar;
